import classnames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { ILanguage } from "../../app/models/company";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

interface IParams {
  languages: ILanguage[];
  selectedLanguage: number;
  onLanguageSelect: (languageId?: number) => void;
  direction?: "right" | "left" | "up" | "down";
  color?: string;
  className?: string;
  flagFontSize?: number;
}

const LanguageDropdown: React.FC<IParams> = ({
  languages,
  selectedLanguage,
  onLanguageSelect,
  direction,
  color,
  className,
  flagFontSize
}) => {
  const [dropdownOpen, setOpen] = useState(false);
  const [t] = useTranslation(["translation"], translationHookOptions); 

  const toggle = () => setOpen(!dropdownOpen);
  const getFlagIcon = () => {
    let filteredLanguages = languages.filter((x) => x.id === selectedLanguage);
    return filteredLanguages.length > 0
      ? filteredLanguages[0].flagIcon
      : languages[0].flagIcon;
  };

  if (!languages || languages.length <= 1) return <></>;

  return (
    <ButtonDropdown isOpen={dropdownOpen} toggle={toggle} direction={direction ? direction : "down"}>
      <DropdownToggle className={className} color={color ? color : "none"} caret>
        {selectedLanguage>0 ? (<>
          <span style={ { fontSize : flagFontSize } } className={classnames("flag-icon", getFlagIcon())}></span>
        
        </>): (<>----</>)}
       
      </DropdownToggle>
      <DropdownMenu>
        {languages.map((l) => (
          <DropdownItem key={l.id}  onClick={() =>
            l.id !== selectedLanguage && onLanguageSelect(l.id)
          }>
             <span className={classnames("mr-1 flag-icon", l.flagIcon)}></span>
              {t(`${l.locale}`, {ns:"translation"})}
       
          </DropdownItem>
        ))}
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default observer(LanguageDropdown);
